<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-onbording`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 13c0-3.314 2.69-6 6-6s6 2.686 6 6-2.69 6-6 6-6-2.686-6-6zm6-10c-5.52 0-10 4.477-10 10s4.48 10 10 10 10-4.477 10-10S26.52 3 21 3zM8.25 36c.89-3.45 4.02-6 7.75-6h8.05a1 1 0 001-1v-2a1 1 0 00-1-1H16C9.37 26 4 31.373 4 38v4c0 1.105.9 2 2 2h18.05a1 1 0 001-1v-2a1 1 0 00-1-1H8v-2c0-.691.09-1.361.25-2zm34.6-4.707l1.413 1.414a1 1 0 010 1.414l-9.899 9.9a.996.996 0 01-.53.277l-.118.014h-.118a.996.996 0 01-.648-.291l-5.657-5.657a1 1 0 010-1.414l1.414-1.415a1 1 0 011.414 0l3.536 3.536 7.778-7.778a1 1 0 011.414 0z"/></svg>
</template>
<script>

export default {
  name: 'IconOnbording',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
